import React from 'react';

export function PublicCompetitionEvents({ competitionName }) {
    return (
        <div>
            <h3>Events für {competitionName}</h3>
            <p>Hier werden die Events/Wettkämpfe angezeigt.</p>
            {/* TODO: Events-Logik implementieren */}
        </div>
    );
}
